<!--eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <div
      v-if="nhl_info_request.isNhlForm"
      class="nhl-info-request-consent"
    >
      <div
        v-if="nhl_info_request.isInCanada"
        class="form-group boolean"
      >
        <div
          class="checkbox"
        >
          <label class="small-label">
            <input
              id="nhl_member_club_info_sharing"
              v-model="nhl_info_request.nhl_member_club_opt_in"
              class="boolean"
              type="checkbox"
              name="marketing_email_consent"
            >
            <span class="custom-checkbox" />
            <span>
              Yes, share my information with the NHL and its <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
                target="_blank"
              >Member Clubs</a> so they may send me news and offers about the NHL and its <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
                target="_blank"
              >Member Clubs</a>.
            </span>
          </label>
        </div>
        <div
          class="checkbox"
        >
          <label class="small-label">
            <!-- id="info_request_marketing_email_consent" -->
            <input
              id="nhl_business_partner_info_sharing"
              v-model="nhl_info_request.nhl_business_partner_opt_in"
              class="boolean"
              type="checkbox"
              name="marketing_email_consent"
            >
            <span class="custom-checkbox" />
            <span>
              Yes, share my information with the NHL so the NHL may send me news and offers that may be of interest to me on behalf of its <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
                target="_blank"
              >Business Partners</a> and share my information with its <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
                target="_blank"
              >Business Partners</a> so they may send me similar messages.
            </span>
          </label>
        </div>
        <div class="checkbox">
          <label class="content-label">
            QuintEvents is seeking your consent on behalf of the NHL and the NHL’s <a
              href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
              target="_blank"
            >Member Clubs</a>, and <a
              href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
              target="_blank"
            >Business Partners</a>. You may withdraw your consent at any time.
          </label>
        </div>

        <div class="checkbox">
          <label class="content-label">
            QuintEvents, 9300 Harris Corners Parkway Suite 120, Charlotte, NC 28269  |  <a
              href="https://quintevents.com/get-in-touch"
              target="_blank"
            >Contact Us</a>  |  <a
              href="https://quintevents.com/privacy-policy"
              target="_blank"
            >QuintEvents Privacy Policy</a>
          </label>
        </div>
        <div class="checkbox">
          <label class="content-label">
            NHL, 1185 Avenue of the Americas, New York, NY 10036  |  <a
              href="https://www.nhl.com/info/contact-us"
              target="_blank"
            >NHL.com/contact</a>   |   <a
              href="https://www.nhl.com/info/privacy-policy"
              target="_blank"
            >NHL Privacy Policy</a>
          </label>
        </div>
      </div>
      <div
        v-else
        class="form-group boolean"
      >
        <div
          class="checkbox"
        >
          <label class="small-label">
            <input
              id="nhl_member_club_info_sharing"
              v-model="nhl_info_request.nhl_member_club_opt_in"
              class="boolean"
              type="checkbox"
              name="marketing_email_consent"
            >
            <span class="custom-checkbox" />
            <span>
              Yes, share my info with the NHL so I can receive news and offers from the NHL and <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs"
                target="_blank"
              >Member Clubs</a>
            </span>
          </label>
        </div>
        <div
          class="checkbox"
        >
          <label class="small-label">
            <!-- id="info_request_marketing_email_consent" -->
            <input
              id="nhl_business_partner_info_sharing"
              v-model="nhl_info_request.nhl_business_partner_opt_in"
              class="boolean"
              type="checkbox"
              name="marketing_email_consent"
            >
            <span class="custom-checkbox" />
            <span>
              Yes, I want news and offers about, and to share my information with, NHL <a
                href="https://www.nhl.com/info/nhl-affiliates-member-clubs#business"
                target="_blank"
              >business partners</a>
            </span>
          </label>
        </div>
        <div class="checkbox">
          <label class="content-label">
            <a
              href="https://www.nhl.com/info/privacy-policy"
              target="_blank"
            >NHL Privacy Policy</a>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {


  props:{
    // eslint-disable-next-line vue/prop-name-casing
    nhl_info_request: {
      default: () => {},
      type: Object
    },
    // eslint-disable-next-line vue/prop-name-casing
    in_eu:{
      default: false,
      type: Boolean
    }
  },
  created(){
    if(this.nhl_info_request.isInsideUS){
      //eslint-disable-next-line vue/no-mutating-props
      this.nhl_info_request.nhl_member_club_opt_in = true
    }
  }
}
</script>
